export default {"src":"/_next/static/media/storm.c07474c5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};